<template>
  <div class="list row">
    <div class="col-md-8">      
     <!-- <div class="input-group mb-3">
        <input type="text" class="form-control" placeholder="Search recipient"
          v-model="receiver"/>
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" type="button"
            @click="seachRecipient"
          >
            Search
          </button>
        </div>
      </div>-->
    </div>
    <div class="col-md-6">   
    <h2>Total</h2>  
    <div id="totalSaludosDiv">
      {{ totalSaludos}}
     </div>
     <br/>

      <h4>Submissions</h4>
      <ul class="list-group">
        <li class="list-group-item"
          :class="{ active: index == currentIndex }"
          v-for="(messages, index) in messages"
          :key="index"
          @click="setActiveMessage(messages, index)"
        >
          {{ messages.receiver }}
        </li>
      </ul>

<!--<button class="m-3 btn btn-sm btn-danger" @click="removeAllMessages">
        Remove All
      </button>-->
    </div>
    <div class="col-md-6">
      
      <div>
        <h1>Top Receiver</h1>
        <div id="topReceiverDiv">
          <div>
            <label><strong>Name:</strong></label> {{ topReceiver }}
          </div>
           <div>
            <label><strong>Saludos Received:</strong></label> {{ topReceiverCount }}
          </div>
        </div>
      
        <br/>
      
        <h1>Latest Saludos</h1>
        <div id="latestSaludosDiv">
          <div>
            <label><strong>Receiver:</strong></label> {{ latestReceiver }}
          </div>
           <div>
            <label><strong>Message:</strong></label> {{ latestMessage }}
          </div>
        </div>
      </div>
      <br/>
      <div v-if="currentMessage">
        <h4>Message</h4>
        <div>
          <label><strong>Timestamp:</strong></label> {{ currentMessage.createdAt }}
        </div>
        <div>
          <label><strong>Sender:</strong></label> {{ currentMessage.sender }}
        </div>
        <div>
          <label><strong>Recipient:</strong></label> {{ currentMessage.receiver}}
        </div>
        <div>
          <label><strong>Message:</strong></label> {{ currentMessage.message}}
        </div>
      </div>
      <div v-else>
        <br />
        <p>Please click on a recipient to view the message...</p>
      </div>
      
    </div>
  </div>
</template>

<script>
import MessageDataService from "../services/MessageDataService";

export default {
  name: "messages-list",
  data() {
    return {
      messages: [],
      currentMessage: null,
      currentIndex: -1,
      title: "",
      totalSaludos: 0,
      latestMessage: '',
      latestReceiver: '',
      topReceiver: '',
      topReceiverCount: ''
    };
  },
  methods: {
    retrieveMessages() {
      MessageDataService.getAll()
        .then(response => {
          this.messages = response.data.result;
          this.latestReceiver = this.messages[0].receiver; 
          this.latestMessage = this.messages[0].message
          this.totalSaludos = this.messages.length
          
          let itemsMap = {}
          let maxValue = 0
          let maxCount = 0

          this.messages.forEach(function(item){
        
              if (itemsMap[item.receiver] == null) {
                  itemsMap[item.receiver] = 1;
              } else {
                  itemsMap[item.receiver]++;
              
              }
              
            if (itemsMap[item.receiver] > maxCount) {
              maxValue = item.receiver;
              maxCount = itemsMap[item.receiver];
            }

            
          })
          this.topReceiver = maxValue
          this.topReceiverCount = maxCount

          console.log(response.data);
        })
        .catch(e => {
          console.log(e);        
        });
    },
    refreshList() {
      this.retrieveMessages();
      this.currentMessage = null;
      this.currentIndex = -1;
    },

    setActiveMessage(message, index) {
      this.currentMessage = message;
      this.currentIndex = message ? index : -1;
    },

    removeAllMessages() {
      MessageDataService.deleteAll()
        .then(response => {
          console.log(response.data);
          this.refreshList();
        })
        .catch(e => {
          console.log(e);
        });
    },
    
    seachRecipient() {
      MessageDataService.findByReceiver(this.receiver)
        .then(response => {
          this.messages = response.data;
          this.setActiveMessage(null);
          console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    }

  },
  mounted() {
    this.retrieveMessages();
  }
};
</script>

<style>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}

#totalSaludosDiv{
  width: 100px;
  font-size: 60px;
  text-align: center;
  outline: 2px solid black;
}

#latestSaludosDiv{
  padding-left: 5px;
  font-size: 20px;
  text-align: left;
  outline: 1px solid black;
}


#topReceiverDiv{
  padding-left: 5px;
  font-size: 20px;
  text-align: left;
  outline: 1px solid black;
}
</style>
